// ----------------------------
// Created by Bulletproof Games
//            2016
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Winline batcher
//
// Takes an object from the server that describes a win and batches it into animation sequences

winlineBatcherLowWin = {};
winlineBatcherLowWin.useWildSymbolAnim = false;

winlineBatcherLowWin.batch = function (winData, controllerName, slotMachine, paylines) {
  let res = [];
  //let symbolSound = "Extra spins spinning";
  // TODO sounds need randomising based on win level
  //   let symbolSound = 'hiWin1';
  let symbolSound = 'winlineBatcherLowWinFakeSound';
  let symbolAnimations = [];
  const paylineData = [];
  for (let i = 0; i < winData.winningLines.length; ++i) {
    paylineData[i] = [];
    const winlineIndex = winData.winningLines[i].winningLine - 1;
    const payline = paylines[winlineIndex];
    for (let w = 0; w < payline.spots.length; w++) {
      paylineData[i].push({
        index: winlineIndex,
        payline: payline,
        reel: w,
        row: payline.spots[w],
      });
    }
    for (let j = 0; j < winData.winningLines[i].occurrences; ++j) {
      var row = winData.winningLines[i].positions[j].row;
      var reel = winData.winningLines[i].positions[j].reel;
      // Check for unqique
      var unique = true;
      for (let m = 0; m < symbolAnimations.length; ++m) {
        if (symbolAnimations[m].reel == reel && symbolAnimations[m].row === row) {
          unique = false;
        }
      }

      if (unique) {
        symbolAnimations.push({
          reel: reel,
          row: row,
          symbolIndex: winData.winningLines[i].symbol.ids[j],
          value: winData.winningLines[i].symbol.value,
          multiplier: 1,
        });
      }
    }
  }
  res.push({
    type: 'WinlineAndSymbol',
    sound: symbolSound,
    data: symbolAnimations,
    paylineData: paylineData,
    slotMachine: slotMachine,
  });
  return res;

  /*
    var i, j, k, l, m;
    var sortedGroups = [];
    var animations = [];
    var group;

 
    // Now find all winlines for this symbol and sort in number of symbols, then winline ascending order
    for (i = 0; i < winData.winningLines.length; i++) {
        var symbolValue = winData.winningLines[i].symbol.value;
        var sortedGroupsIndex = symbolIds.indexOf(symbolValue);
        group = sortedGroups[sortedGroupsIndex];

        if (group.numSymbols.indexOf(winData.winningLines[i].occurrences) === -1) {
            group.numSymbols.push(winData.winningLines[i].occurrences);
        }
    }

    for (i = 0; i < sortedGroups.length; i++) {
        sortedGroups[i].numSymbols.sort();
    }

    // Now create winline animation for each group
    for (i = 0; i < sortedGroups.length; i++) {
        var symbolIndex =  symbolIds[i];
        var maxSymbolsInWinline = 0;
        group = [];
        for (j = 0; j < sortedGroups[i].numSymbols.length; j++) {
            var numSymbols = sortedGroups[i].numSymbols[j];
            for (k = 0; k < winData.winningLines.length; k++) {
                if (winData.winningLines[k].symbol.value === symbolIndex && winData.winningLines[k].occurrences === numSymbols) {
                    group.push(winData.winningLines[k]);
                    if (maxSymbolsInWinline < numSymbols) {
                        maxSymbolsInWinline = numSymbols;
                    }
                }
            }

        }

        // Add to animation sequence
        var symbolAnimations = [];
        var soundFile = resourceManager.getController(controllerName).Props.winlineSound;

        for (k = 0; k < group.length; k++) {
            animations.push({ type: "Winline", sound: sprintf(soundFile, k), data: group[k], slotMachine: slotMachine });
            for (l = 0; l < group[k].occurrences; l++) {
                var row = group[k].positions[l].row;
                var reel = group[k].positions[l].reel;
                // Check for unqique
                var unique = true;
                for (m = 0; m < symbolAnimations.length; m++) {
                    if (symbolAnimations[m].reel == reel && symbolAnimations[m].row === row) {
                        unique = false;
                    }
                }

                if (unique) {
                    symbolAnimations.push( {
                        reel: reel,
                        row: row,
                        symbolIndex: winlineBatcherLowWin.useWildSymbolAnim ? group[k].symbol.ids[l] : group[k].symbol.value,
                        value: group[k].symbol.value,
                        multiplier: (group[k].multipliers !== undefined) ? group[k].multipliers[l] : 1});
                }
            }
        }

        if(gameController.canCelebrate || freespins.inFreespins) {
            var symbolSound = undefined;
            var symbolTemplate = resourceManager.getConfiguration().symbols[Object.keys(resourceManager.getConfiguration().symbols)[symbolIndex]];
            if (typeof (symbolTemplate.soundFile) !== "undefined") {
                // Single sound for all wins on this winline
                symbolSound = symbolTemplate.soundFile;
            } else if (typeof (symbolTemplate["soundFile_x" + maxSymbolsInWinline]) !== "undefined") {
                // Different sound for wins on this winline
                symbolSound = symbolTemplate["soundFile_x" + maxSymbolsInWinline];
            }

            animations.push({type: "Symbol", sound: symbolSound, data: symbolAnimations, slotMachine: slotMachine});
        }
        else if (!gameController.canCelebrate){
            animations.push({type: "Symbol", sound: undefined, data: symbolAnimations, slotMachine: slotMachine});
        }
    }

    return animations;
    */
};

winlineBatcherLowWin.setUseWildSymbolAnim = function (val) {
  winlineBatcherLowWin.useWildSymbolAnim = val;
};

resourceManager.registerPlugIn('winlineBatcherLowWin', winlineBatcherLowWin);
